module.exports = __webpack_public_path__ + "src/assets/img/cig-case.ff26a1ce.png";